import { createInjection } from '@/lib/createInjection';
import { JohaisetsuCarShowResponse } from '@/models/apis/johaisetsu/johaisetsuCarResponse';

export type MyJohaisetsuCarContainer = {
  current: JohaisetsuCarShowResponse | null;
  // car取得に失敗した場合true。作業開始ボタンの非活性化に使う
  carFetchFailed: boolean;
};

const { provide, inject } = createInjection<MyJohaisetsuCarContainer>('johaisetsuSagyou/myJohaisetsuCar');

export function provideMyJohaisetsuCar(container: MyJohaisetsuCarContainer): void {
  provide(container);
}

export function useMyJohaisetsuCar(): MyJohaisetsuCarContainer {
  return inject();
}
